'use strict';

import Vue from 'vue'
import Vuex from 'vuex'
import app from '@/store/modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app
  }
})
